export const CURRENCY_SYMBOL = process.env.REACT_APP_CURRENCY_SYMBOL || '₹';
export const CURRENCY_CODE = process.env.REACT_APP_CURRENCY_CODE || 'INR';

export function formatCurrency(value) {
  return `${CURRENCY_SYMBOL}${Number(value || 0).toLocaleString('en-IN')}`;
}
